import { useInstallPromptContext } from "@/context/InstallPromptInitializer";
import customAlert from "@/util/customAlert";
import redirectInappToChrome from "@/util/redirectInappToChrome";
import { useLocale, useTranslations } from "next-intl";


export default function useInstallPrompt() {
    const { deferredPrompt, setDeferredPrompt } = useInstallPromptContext()

    const locale = useLocale();
    const a = useTranslations("Sentence")
    
    const installApp = async () => {
        if (!deferredPrompt) {
            // alert("설치 가능한 PWA가 없습니다.")
            // 크롬/사파리 제외 브라우저
            customAlert((a.rich("unsupportedA2HS", { br: (c) => <br /> }) as string), 'warning',
                () => { redirectInappToChrome(false, locale) }, { htmlMode: true }
            )

            return
        }

        await deferredPrompt.prompt()
        setDeferredPrompt(null) // 이벤트는 한 번만 유효하므로 초기화
    }

    return { installApp }
}